import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { getFilmAvailability } from './get-film-availability';
import { isFilmAvailableForAdvanceBookings } from './is-film-available-for-advance-bookings';
export const isFilmAvailableForBookings = (filmId, siteId) => {
    const filmAvailability = getFilmAvailability(filmId, siteId);
    if (!filmAvailability)
        throw new Error(`Cannot find film availability with filmId: ${filmId}.`);
    return (filmAvailability.categories.includes(FilmCategory.NowShowing) ||
        isFilmAvailableForAdvanceBookings(filmId, siteId));
};
